<template>
  <div class="container">
    <van-image style="display: block; margin: 0 auto" :src="require('@/assets/sign-up.png')"></van-image>
    <section class="demand">
      <h3>志愿者招募要求：</h3>
      <div class="require" v-html="notice.recruitRequire"></div>
      <ul>
        <li><span>面向观众：</span><div>{{ notice.objectOriented }}</div></li>
        <li><span>报名期限：</span><div>{{ notice.registrationPeriod }}</div></li>
        <li><span>咨询电话：</span><div>{{ notice.consultationPhone }}</div></li>
      </ul>
    </section>
    <van-form class="form" label-align="right" label-width="90" @submit="onSubmit" colon scroll-to-error>
      <section class="register-information">
        <van-image class="title-icon" :src="require('@/assets/baoming.png')"></van-image>
        <!-- eslint-disable no-irregular-whitespace-->
        <van-field
          v-model="form.username"
          name="username"
          label="姓　　名"
          required
          placeholder="请输入"
          :rules="[{ required: true, message: '请填写姓名' }]"
        />
        <van-field name="radio" label="性　　别" required :rules="[{ required: true, message: '请选择性别' }]">
          <template #input>
            <div style="padding-top: 7px">
              <van-radio-group checked-color="#BF6A55" icon-size="15px" v-model="radio" direction="horizontal">
                <van-radio name="1">男</van-radio>
                <van-radio name="2">女</van-radio>
              </van-radio-group>
            </div>
          </template>
        </van-field>
        <van-field
          v-model="form.age"
          name="username"
          label="年　　龄"
          required
          placeholder="请输入"
          :rules="[{ required: true, message: '请填写年龄' }]"
        />
        <van-field
          v-model="form.idNumber"
          name="idNumber"
          label="身份证号"
          required
          placeholder="请输入"
          :rules="[{ required: true, message: '请正确填写身份证号', pattern: /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/ }]"
        />
        <van-field
          v-model="form.phoneNumber"
          name="phoneNumber"
          label="联系方式"
          required
          placeholder="请输入"
          :rules="[{ required: true, message: '请正确填写联系方式', pattern: /^(13[0-9]|14[5|7]|15[0|1|2|3|4|5|6|7|8|9]|18[0|1|2|3|4|5|6|7|8|9])\d{8}$/ }]"
        />
        <van-field
          v-model="form.unit"
          name="unit"
          label="工作单位"
          required
          placeholder="请输入"
          :rules="[{ required: true, message: '请填写工作单位'}]"
        />
        <van-field
          v-model="form.introduce"
          name="introduce"
          rows="3"
          autosize
          label="个人介绍"
          required
          type="textarea"
          maxlength="100"
          show-word-limit
          placeholder="请输入"
          :rules="[{ required: true, message: '请填写个人介绍' }]"
        />
        <van-field
          readonly
          clickable
          name="picker"
          :value="selectvalue"
          label="服务地点"
          class="fwdd"
          placeholder="点击选择服务地点"
          @click="showPicker = true"
          required
          :rules="[{ required: true, message: '请选择服务地点' }]"
        />
        <van-field label="服务时间" class="timeBox" required>
          <template #input>
            <div class="okTime" @click="timeVisibile = !timeVisibile">选择服务时间</div>
            <div class="selectTitle-box" v-show="timeVisibile">
              <div class="selectTitle okBtn">
                <div @click="ok">完成</div>
              </div>
              <div class="selectTitle">
                <div>时间</div>
                <div style="padding-right: 15px">日期</div>
              </div>
              <van-tree-select
                height="240"
                :items="items"
                :active-id.sync="activeIds"
                :main-active-index.sync="activeIndex"
                @click-nav="clickNav"
                @click-item="clickItem"
              />
            </div>
          </template>
        </van-field>
        <van-popup v-model="showPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="columns"
            value-key="title"
            @confirm="onConfirm"
            @cancel="showPicker = false"
          />
        </van-popup>
      </section>
      <section class="upload-personal">
        <van-image class="title-icon" :src="require('@/assets/zhaopian.png')"></van-image>
        <van-uploader
          class="upload"
          v-model="form.Upersonal"
          preview-size="26.5vw"
          :after-read="afterRead"
          max-count="1"
        />
      </section>
      <section class="upload-qualifications">
        <van-image class="title-icon" :src="require('@/assets/zhaopianshangchuan.png')"></van-image>
        <van-uploader
          class="upload"
          v-model="form.Uqualifications"
          preview-size="26.5vw"
          multiple
          :after-read="afterRead"
          max-count="6"
        />
      </section>
      <section class="btns">
        <van-button native-type="submit" round block color="#BF6A55" text="确认" />
      </section>
    </van-form>
    <van-popup
      class="popup"
      round
      :overlay-style="{ backgroundColor: 'rgba(0, 0, 0, .5)' }"
      v-model="showPopup"
      :close-on-click-overlay="false"
      @opened="onPopupOpened"
    >
      <template v-if="time">
        <span class="count-down">倒计时{{ time }}s</span>
      </template>
      <template v-else>
        <span class="count-down" @click="handlePopupStatus">关闭</span>
      </template>
      <van-image width="100%" :src="require('@/assets/zyzzc.png')" />
      <div class="content" v-html="notice.regulation"></div>
    </van-popup>
  </div>
</template>

<script>
import { getRequestNotice, getSignList, submitApply, uploadToServer } from '@/api/volunteer'
export default {
  name: 'VolunteerSignUp',
  data: () => ({
    timeVisibile: false,
    requireText: '',
    notice: {
      regulation: '',
      recruitRequire: ''
    },
    form: {
      username: null,
      idNumber: null,
      phoneNumber: null,
      introduce: null,
      Upersonal: [],
      Uqualifications: [],
      type: null
    },
    selectvalue: '',
    showPopup: false,
    time: 10,
    columns: [],
    showPicker: false,
    activeIds: [],
    activeIndex: 0,
    items: [
      {
        // 导航名称
        text: '9:00 ~ 12：00',
        // 是否在导航名称右上角显示小红点
        // 导航节点额外类名
        className: 'my-class',
        // 该导航下所有的可选项
        children: [
          {
            text: '星期二',
            val: 1,
            id: 1
          },
          {
            text: '星期三',
            val: 2,
            id: 2
          },
          {
            text: '星期四',
            val: 3,
            id: 3
          },
          {
            text: '星期五',
            val: 4,
            id: 4
          },
          {
            text: '星期六',
            val: 5,
            id: 5
          },
          {
            text: '星期日',
            val: 6,
            id: 6
          }
        ]
      },
      {
        // 导航名称
        text: '14:00 ~ 17：00',
        // 是否在导航名称右上角显示小红点
        // 导航节点额外类名
        className: 'my-class',
        // 该导航下所有的可选项
        children: [
          {
            text: '星期二',
            val: 1,
            id: 7
          },
          {
            text: '星期三',
            val: 2,
            id: 8
          },
          {
            text: '星期四',
            val: 3,
            id: 9
          },
          {
            text: '星期五',
            val: 4,
            id: 10
          },
          {
            text: '星期六',
            val: 5,
            id: 11
          },
          {
            text: '星期日',
            val: 6,
            id: 12
          }
        ]
      }
    ],
    patenteeNames: [],
    arr1: [],
    arr2: [],
    fwTime: [],
    radio: '1'
  }),
  created () {
    console.log(this.$route)
    this.getList()
    this.getNotice()
  },
  mounted () {
    this.showPopup = true
  },
  methods: {
    ok () {
      const a = this.items[0].children.filter(v => this.arr1.includes(v.id)).map(v => '1' + '-' + v.val)
      const b = this.items[1].children.filter(v => this.arr2.includes(v.id)).map(v => '2' + '-' + v.val)
      this.fwTime = [...a, ...b]
      this.timeVisibile = false
    },
    // 左侧
    clickNav (index) {
    },
    // 右侧
    clickItem (data) {
      this.arr1 = this.activeIds.filter(v => v <= 6).map(v => v)
      this.arr2 = this.activeIds.filter(v => v > 6).map(v => v)
    },
    async getList () {
      const { result } = await getSignList()
      console.log(result)
      this.columns = result
    },
    onConfirm (value) {
      console.log(value)
      this.selectvalue = value.title
      this.form.type = value.value
      this.showPicker = false
    },
    async getNotice () {
      const { result } = await getRequestNotice()
      this.notice = result
    },
    async onSubmit () {
      if (this.notice.isRegisted === '0') {
        this.$toast.fail('不在报名期限内')
        return
      }
      const Uqualifications = []
      let Upersonal
      if (this.form.Upersonal.length > 0) {
        console.log('个人照片')
        const { result } = await uploadToServer(this.form.Upersonal[0].file)
        Upersonal = result
      }
      if (this.form.Uqualifications.length > 0) {
        for (const index in this.form.Uqualifications) {
          console.log(this.form.Uqualifications[index].file)
          const { result } = await uploadToServer(this.form.Uqualifications[index].file)
          Uqualifications.push(result)
        }
      }
      try {
        const { result } = await submitApply({
          type: this.form.type,
          name: this.form.username,
          identityNumber: this.form.idNumber,
          contact: this.form.phoneNumber,
          personalIntroduction: this.form.introduce,
          personalPhoto: Upersonal,
          qualificationCertificatePhoto: Uqualifications,
          age: this.form.age,
          gender: this.radio,
          serviceTime: this.fwTime,
          unit: this.form.unit,
          serviceLocation: this.form.serviceLocation
        })
        console.log(result)
        this.$toast.success('报名成功')
        this.$router.replace('/volunteer/signUpResult')
      } catch (err) {
        this.$toast.fail(err)
      }
    },
    async afterRead (e) {
      console.log(e)
    },
    onPopupOpened () {
      console.log('打开了')
      let timer = null
      timer = setInterval(() => {
        if (this.time > 0) {
          this.time--
        } else {
          clearInterval(timer)
        }
      }, 1000)
    },
    handlePopupStatus () {
      this.showPopup = !this.showPopup
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .van-tree-select__selected {
  color: #BF6A55;
  border: 1px solid #BF6A55;
  border-radius: 50%;
  transform: scale(.7);
  margin-top: -10px;
}
::v-deep .van-field__control--custom {
  display: block;
}
::v-deep .van-sidebar-item {
  background-color: #F7EEE8;
}
::v-deep .van-tree-select__content {
  flex: 1;
  text-align: center;
}
::v-deep .van-tree-select__nav-item {
  text-align: center;
}
::v-deep .van-sidebar-item--select::before {
  display: none;
}
::v-deep .van-tree-select__nav {
  background-color: #F7EEE8;
}
::v-deep .van-sidebar-item--select {
  background-color: #FFF8F4;
}
::v-deep .van-cell__title {
  padding-right: 15px;
  padding-top: 5px;
}
::v-deep .van-tree-select__item {
  line-height: 2.75;
  color: #999999;
}
::v-deep .van-tree-select__item--active {
  color: #000000;
}
::v-deep .van-tree-select__nav-item {
  padding: 10px 0;
}
::v-deep .van-tree-select__content {
  background-color: #FFF8F4;
}
::v-deep .van-uploader__upload {
  margin-right: 0;
}
::v-deep .fwdd {
  padding-top: 10px !important;
}
.container {
  padding: 20px 30px;
  box-sizing: border-box;
  min-height: 100vh;
  background-color: #F7EEE8;
  font-family: 'PingFangMedium';
  .van-cell--required::before {
    top: 10px;
  }
  ::v-deep .timeBox {
    position: relative;
    .van-field__error-message {
      position: absolute;
      top: 5px;
      right: 10px;
    }
    .okTime {
      display: inline-block;
      border: 0;
      background-color: rgb(191, 106, 85);
      color: #fff;
      font-size: 13px;
      padding: 3px 10px;
      border-radius: 6px;
      margin-top: 3px;
      margin-bottom: 12px;
    }
    .selectTitle-box {
      right: 0;
      top: 40px;
      position: absolute;
      z-index: 1;
      width: 98%;
      box-shadow: 0px 0px 10px 0px rgba(131, 95, 75, 0.2);
      .selectTitle {
        width: 100%;
        padding: 10px 0;
        text-align: center;
        background-color: #F7EEE8;
        div {
          box-sizing: border-box;
          width: 50%;
          display: inline-block;
          color: #000;
        }
      }
      .okBtn {
        text-align: right;
        padding: 2px 0;
        padding-right: 10px;
        padding-top: 10px;
        box-sizing: border-box;
        font-size: 14px;
        div {
          width: auto;
          padding: 0px 10px;
          border-radius: 6px;
          display: inline-block;
          background-color: rgb(191, 106, 85);
          color: #fff;
        }
      }
    }
  }
  ::-webkit-input-placeholder { color:#BAA69C; }
  .demand {
    //border: 1px solid #aaa;
    border-radius: 3px;
    //box-shadow: inset 0 0 8px #ccc;
    margin-top: 30px;
    padding: 10px 16px;
    box-sizing: border-box;
    color: #312925;
    background-color: #F1E6DD;
    border-radius: 3px;
    h3 {
      font-size: 16px;
      margin-top: 0;
    }
    .require {
      ::v-deep ol {
        list-style: decimal inside;
        font-size: 12px;
        line-height: 2;
      }
    }

    ul {
      margin-top: 15px;
      line-height: 2;
      font-size: 14px;
      span {
        font-weight: bold;
      }
    }
  }
  .form {
    ::v-deep .nameyz {
      &::before {
        left: 36px;
      }
    }
    > section {
      margin-top: 25px;
    }
    .register-information {
      .title-icon {
        width: 108px;
        height: 32px;
      }
      ::v-deep .van-cell {
        background-color: transparent;
        .van-field__label {
          width: 5em;
          margin-right: 0;
        }
        &.van-field {
          padding: 5px 0 5px 15px;
        }
        .van-field__word-limit {
          margin-top: -18px;
          margin-right: 8px;
          color: #BAA69C;
        }
        .van-field__body {
          input, textarea {
            //border: 1px solid #aaa;
            //box-shadow: inset 0 0 3px #ccc;
            background-color: #F1E6DD;
            border-radius: 3px;
            padding: 0 6px;
          }
          input {
            height: 35px;
          }
          textarea {
            height: 100px;
          }
        }
      }
    }
    ::v-deep .van-uploader__preview {
      &:nth-of-type(3n + 0) {
        margin-right: 0;
      }
    }
    .upload-personal, .upload-qualifications {
      .title-icon {
        margin-bottom: 10px;
        display: block;
        height: 25px;
      }
    }
    .upload-personal {
      .title-icon {
        width: 141px;
      }
    }
    .upload-qualifications {
      .title-icon {
        width: 181px;
      }
    }
    .btns {
      .van-button {
        font-size: 16px;
        &:first-child {
          margin-bottom: 20px;
        }
      }
    }
  }
  .popup {
    width: 70vw;
    height: 60vh;
    padding: 10px 16px;
    background-color: #F7EEE8;
    .count-down {
      border: 1px solid #312925;
      border-radius: 12px;
      padding: 4px 12px;
      box-sizing: border-box;
      font-size: 14px;
      float: right;
      margin-bottom: 10px;
    }
    .content {
      height: 80%;
      overflow-x: hidden;
      overflow-y: scroll;
      padding-right: 10px;
      text-align: justify;
    }
    ::v-deep p {
      color: #312925;
      font-size: 12px;
      line-height: 2;
    }
  }
}
</style>
